<template>
  <div v-if="!isLoading && !TriggerUrl" class="onboarding-tours sf-be -sf-mb-xs ng-star-inserted">
    <h2>Quick Onboarding:</h2>
    <div>
      <div class="sf-row -sf-mb-xs">
        <div class="sf-row__col -sf-pr-3xs -col-6">
          <a v-for="(reportItem, reportIndex) in SectionReport" :key="'itm-' + reportIndex"
            @click="SelectedNode = reportItem" class="-sf-hover-bg-light-grey -sf-p-3xs sf-row" style="
              padding: 10px !important;
              cursor: pointer;
              position: relative;
            ">
            <a :href="GetItemRedirectUrl(reportItem.Item)" target="_blank"
              style="position: absolute; right: 5px; top: 5px">
              <FeatherIcon style="color: silver; width: 16px; height: 16px" icon="ExternalLinkIcon"></FeatherIcon>
            </a>
            <FeatherIcon icon="BookOpenIcon" :style="GetItemIconStyle(reportItem)"></FeatherIcon>
            <div class="-sf-overflow-hidden -fill" style="width: 250px">
              <div class="h5">{{ reportItem.SectionTag.Title }}</div>
              <div title="create a page" class="-sf-ellipsis -sf-mt--4xs -sf-txt-primary-invert h3">
                {{ reportItem.Item.Title }}
              </div>
            </div>
          </a>
        </div>
        <div class="sf-row__col -sf-pl-3xs -col-6">
          <div v-if="SelectedNode != null">
            <a v-for="(reportItem, reportIndex) in SelectedNode.ChildStats" :key="'itm-' + reportIndex"
              :href="GetItemRedirectUrl(reportItem)" target="_blank" class="-sf-hover-bg-light-grey -sf-p-3xs sf-row"
              style="padding: 10px !important">
              <FeatherIcon :style="GetSingleItemStyle(reportItem)" icon="BookOpenIcon"></FeatherIcon>
              <div class="-sf-overflow-hidden -fill" style="width: 250px">
                <div class="h5">{{ reportItem.Title }}</div>
                <div title="create a page" class="-sf-ellipsis -sf-mt--4xs -sf-txt-primary-invert h3">
                  {{ reportItem.Title }}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <br />
    <a href="/working/interview" style="margin-left: 50px">Need help? Want to apprise someone?</a>
  </div>
</template>
<script>
import FeatherIcon from "@/components/FeatherIcon.vue";
import EmbedsService from "@/embeds/embedService.js";
import Interview from "@/views/working/Interview.vue";

export default {
  data() {
    return {
      SectionReport: [],
      SelectedNode: null,
      forUser: null,
      projectId: null,
      isLoading: true,
      TriggerUrl: null
    };
  },
  methods: {
    GetItemIconStyle(embed) {
      var color = "gray";
      var numAssessed = 0;
      var numRead = 0;
      var numWithNewInfo = 0;

      for (var i = 0; i < embed.ChildStats.length; i++) {
        var item = embed.ChildStats[i];

        if (item.HasCorrectAssessment) {
          numAssessed++;
        }
        if (item.HasBeenRead) {
          numRead++;
        }
        if (item.HasNewInfoSince) {
          numWithNewInfo++;
        }
      }

      if (numAssessed == embed.ChildStats.length) {
        color = "rgb(56, 171, 99);";
      } else if (numRead > 0) {
        color = "silver;";
      } else if (numWithNewInfo > 0) {
        color = "silver;";
      }

      return "width: 40px;float: left;color: " + color + ";margin-right: 1px;";
    },
    GetSingleItemStyle(item) {
      var color = "gray";
      if (item.HasCorrectAssessment) {
        color = "rgb(56, 171, 99);";
      }

      return "width: 40px;float: left;color: " + color + ";margin-right: 1px;";
    },

    GetItemRedirectUrl(embed) {
      return (
        window.location.protocol +
        "//" +
        window.location.host +
        "/pages/context-and-onboarding??eid=" +
        embed.Id
      );
    },

    LoadReport() {
      var instance = this;

      if (this.ProjectId && this.ForUserCalculated()) {
        EmbedsService.getOnboardingSectionOverview(
          this.ProjectId,
          this.ForUserCalculated()
        ).then(function (response) {
          instance.$set(instance, "SectionReport", response.data.SectionReport);
          instance.$set(instance, "isLoading", false);
        });
      }
    },

    ForUserCalculated() {
      var result = this.forUser || this.ForUser;
      return result;
    },
  },
  mounted() {
    if (this.$route.query.triggerurl) {
      alert(this.$route.query.triggerurl);
      this.$set(this, "TriggerUrl", this.$route.query.triggerurl);
    }
    if (this.$route.query.projectId && this.$route.query.forUser) {
      var project = this.$route.query.projectId;
      var forUser = this.$route.query.forUser;

      this.$set(this, "forUser", forUser);
      this.$set(this, "projectId", project);
    }

    this.LoadReport();
  },
  props: {
    ProjectId: {
      type: String,
      required: false,
    },
    ForUser: {
      type: Number,
      required: false,
    },
  },
  watch: {
    ProjectId(newVal) {
      this.$set(this, "projectId", newVal);
      this.LoadReport();
    },
    ForUser(newVal) {
      this.LoadReport();
    },
  },
  components: {
    FeatherIcon,
    Interview,
  },
};
</script>
<style>
.onboarding-tours {
  font-family: "Open Sans Condensed", sans-serif;
  padding: 30px;
}

h2 {
  font-size: 20px;
  font-weight: 300;
  line-height: 1.3;
  color: var(--color-h2);
  margin-top: 0;
  margin-bottom: 20px !important;
}

.h3 {
  font-family: "Open Sans Condensed", sans-serif;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.3;
  margin-top: 0;
  margin-bottom: 0;
}

.h5 {
  font-size: 10px;
  font-weight: normal;
  color: #999;
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 0;
}

.sf-row {
  display: flex;
  flex-wrap: wrap;
  /* padding: 0; */
  width: 100%;
  max-width: 100%;
  list-style-type: none;
}

.-sf-pr-3xs {
  padding-right: 10px !important;
}

.col-6,
.-col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.-sf-hover-bg-light-grey:hover {
  background: #f5f5f5 !important;
}
</style>
